import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Container from "./Container.jsx";
import axios from "axios";

import Entity from "../datasource/Entity";
import Reservations from "../components/Views/Reservations.jsx";
import { SEARCH_FIELD_TYPES, SEARCH_ERROR_MSG } from "../lib/data";
import clientConfig from "../config/client";

class ReservationsASUContainer extends Container {
    constructor(props) {
        super(props);
        this.initDatasource("reservations_asu");
        this.state = {
            ...this.state,
            loading: true,
            getParams: { ...this.globalSearch.search.reservations },
        };
    }

    componentDidMount = async () => {
        await this.getAuxData();
        await this.getCodes();
    };

    hotelId = this.props.match.params.mainId;

    getCodes = async () => {
        const data = await (
            await fetch(
                `/manager/data/hotels/${this.hotelId}/reservations_asu/get_codes`,
            )
        ).json();

        this.statusCodes = data.status_codes || [];
        this.rateCodes = data.rate_codes || [];
        this.roomTypesCodes = data.room_type_codes || [];
        this.orderSources = data.order_sources || [];

        this.forceUpdate();
    };

    getBackLinkToReservations = () => this.datasource.routes().home;

    handleSearchError = (errorResp) => {
        const locale = clientConfig.locale;
        const errorFieldsArr = Object.keys(errorResp.data);
        const errorFiledsLocaleLabels = [];

        for (const key of errorFieldsArr) {
            for (const searchEntity in SEARCH_FIELD_TYPES) {
                if (SEARCH_FIELD_TYPES[searchEntity].name === key) {
                    errorFiledsLocaleLabels.push(
                        `${SEARCH_FIELD_TYPES[searchEntity].label[locale]} - ${errorResp.data[key]} `,
                    );
                }
            }
        }

        const errorMsg =
            SEARCH_ERROR_MSG.label[locale] +
            "[" +
            errorFiledsLocaleLabels +
            "]";

        return alert(errorMsg);
    };

    getGuestData = (id) => {
        const guestsEntity = new Entity("guests");

        guestsEntity
            .getOne(id)
            .then((response) => this.setState({ curGuest: response }))
            .catch((e) => {
                alert("Ошибка получения данных гостя!");
                throw new Error(e);
            });
    };

    getAll = (params = {}) => {
        const path = this.datasource.dataPath + "/" + this.modelName;

        return axios.get(path, { params }).then((response) => response.data);
    };

    getAllItems = (params) =>
        this.getAll(params)
            .then((resData) =>
                this.setState({
                    AllItems: resData.data,
                    currentPage: resData.current_page,
                    firstPageUrl: resData.first_page_url,
                    from: resData.from,
                    loading: false,
                    lastPage: resData.last_page,
                    lastPageUrl: resData.last_page_url,
                    nextPageUrl: resData.next_page_url,
                    path: resData.path,
                    perPage: resData.per_page,
                    prevPageUrl: resData.prev_page_url,
                    to: resData.to,
                    total: resData.total,
                }),
            )
            .catch((error) => {
                this.handleSearchError(error.response);
            });

    paramsChangeHandler = (newParams) => this.getAllItems(newParams);
    setCustomLoading = (loading) =>
        this.setState((state) => ({
            ...state,
            loading: loading,
        }));

    render = () => {
        const fields = this.datasource.getSchemaFields();
        const routes = this.datasource.routes();

        const auxDataRoomTypes =
            this.props?.auxData && this.props.auxData.room_types;
        const auxDataRates = this.props?.auxData && this.props.auxData.rates;

        const columns = [
            { id: "id", label: "id" },
            { id: "number", label: "Номер" },
            {
                id: "guest_phone",
                label: "Телефон гостя",
            },
            { id: "guest_name", label: "Гость" },
            { id: "created_at", label: "Дата создания" },
            {
                id: "date_in",
                label: "Дата заезда",
            },
            { id: "date_out", label: "Дата выезда" },
            {
                id: "external_id",
                label: "Внешний номер",
            },
            { id: "status_code", label: "Статус" },
            {
                id: "order_source",
                label: "Источник",
            },
            { id: "room_type_code", label: "Категория номера" },
            {
                id: "rate_code",
                label: "Тариф",
            },
            { id: "total", label: "Сумма" },
        ];

        if (this.state.error && this.state.error.status == 403) {
            return <Route render={() => <Redirect to="/hotels" replace />} />;
        }

        const inputFilter = {
            rateCodes: this.rateCodes,
            statusCodes: this.statusCodes,
            roomTypesCodes: this.roomTypesCodes,
            orderSources: this.orderSources,
        };

        return (
            <Switch>
                <Route path={routes.home} exact>
                    <Reservations
                        title={"Заявки на бронирование"}
                        getAllItems={this.getAllItems}
                        editAction={this.getEditLink}
                        roomTypes={auxDataRoomTypes}
                        inputFilter={inputFilter}
                        columns={columns}
                        rates={auxDataRates}
                        reservationsData={this.state}
                        fields={fields}
                        paramsChangeHandler={this.paramsChangeHandler}
                        globalSearch={this.globalSearch}
                        updateGlobalSearch={this.updateGlobalSearch}
                        hotelId={this.hotelId}
                        setLoading={this.setCustomLoading}
                        user={this.props.user}
                        thisReservationsASU={true}
                    />
                </Route>
            </Switch>
        );
    };
}

export default ReservationsASUContainer;
